export default __webpack_public_path__ + "static/media/gulamarggondola.899ccc8a.jpg";